import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const SearchCompletedEventSchema = (): EventSchema => {
  return {
    eventName: EN.SEARCH_COMPLETED,
    params: {
      // common properties
      ...CommonEventProperties,

      // specific properties
      BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
      EVENT_CATEGORY: EPK.EVENT_CATEGORY,
      SEARCH_FEATURE_SELECTED: EPK.SEARCH_FEATURE_SELECTED,
      SEARCH_FEATURE_POSITION: EPK.SEARCH_FEATURE_POSITION,
      SEARCH_SUGGESTED_CAMPAIGN_NAME: EPK.SEARCH_SUGGESTED_CAMPAIGN_NAME,
      SEARCH_SUGGESTED_CAMPAIGN_NAME_COUNT:
        EPK.SEARCH_SUGGESTED_CAMPAIGN_NAME_COUNT,
      SEARCH_POPULAR_CATEGORY_KEYWORDS: EPK.SEARCH_POPULAR_CATEGORY_KEYWORDS,
      SEARCH_POPULAR_CATEGORY_KEYWORDS_COUNT:
        EPK.SEARCH_POPULAR_CATEGORY_KEYWORDS_COUNT,
      SEARCH_RECENT_KEYWORDS: EPK.SEARCH_RECENT_KEYWORDS,
      SEARCH_RECENT_KEYWORDS_COUNT: EPK.SEARCH_RECENT_KEYWORDS_COUNT,
      SEARCH_REFINEMENT_KEYWORDS: EPK.SEARCH_REFINEMENT_KEYWORDS,
      SEARCH_REFINEMENT_KEYWORDS_COUNT: EPK.SEARCH_REFINEMENT_KEYWORDS_COUNT,
      SEARCH_AUTOCOMPLETE_KEYWORDS: EPK.SEARCH_AUTOCOMPLETE_KEYWORDS,
      SEARCH_AUTOCOMPLETE_KEYWORDS_COUNT:
        EPK.SEARCH_AUTOCOMPLETE_KEYWORDS_COUNT,
      SEARCH_TRENDING_KEYWORDS: EPK.SEARCH_TRENDING_KEYWORDS,
      SEARCH_TRENDING_KEYWORDS_COUNT: EPK.SEARCH_TRENDING_KEYWORDS_COUNT,
      SEARCH_TERM: EPK.SEARCH_TERM,
      SEARCH_TERM_TYPED: EPK.SEARCH_TERM_TYPED,
      SEARCH_PRODUCT_COUNT: EPK.SEARCH_PRODUCT_COUNT,
      SEARCH_SEGMENTS: EPK.SEARCH_SEGMENTS,
    },
  }
}
